define('shared/util/adyen/hideStoreDetailsTickboxes',[
    './addCSSClassForStoreDetails',
    './lockStoreDetails'
], function (
    addCSSClassForStoreDetails,
    lockStoreDetails
) {
    return function ($form) {
        function observerCallback() {
            lockStoreDetails($form, true);
            addCSSClassForStoreDetails($form);
        }

        var config = { childList: true, subtree: true };
        lockStoreDetails($form, true);
        addCSSClassForStoreDetails($form);
        var observer = new MutationObserver(observerCallback);
        observer.observe($form[0], config);
    };
});
